import { render, staticRenderFns } from "./GroupOrderList.vue?vue&type=template&id=2ff5a788&scoped=true"
import script from "./GroupOrderList.vue?vue&type=script&lang=js"
export * from "./GroupOrderList.vue?vue&type=script&lang=js"
import style0 from "./GroupOrderList.vue?vue&type=style&index=0&id=2ff5a788&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5a788",
  null
  
)

export default component.exports